import PlayLeftIcon from "@svg/new-design/play-left";
import { FC, useRef } from "react";
interface Props {
  degrees: {
    id: number;
    degree: string;
    grade: string;
    university: string;
    instructor_id: number;
    deleted_at: string | null;
    created_at: string;
    updated_at: string;
  }[];
}
const InstructorDegreeLayout: FC<Props> = ({ degrees }) => {
  const contentRef = useRef<HTMLDivElement>(null);

  return (
    <div className="w-full">
      <div
        ref={contentRef}
        className="mt-6  flex flex-col-reverse  gap-y-6  overflow-hidden body-md text-fds-secondary "
      >
        {degrees.map((degree, idx) => (
          <div className="flex gap-x-1 " key={idx}>
            <PlayLeftIcon className="w-5    mt-0.5 h-5    text-fds-icon-brand" />
            <div className="flex flex-col gap-y-1.5">
              <p className="title-lg text-fds-primary">
                {degree.degree}
                {` ${degree.grade}`}
              </p>

              <p className="body-md text-fds-secondary">{degree.university}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
export default InstructorDegreeLayout;
